export const types = {
  INITIALIZE: 'SESSION/INITIALIZE'
};

export const creators = {};
